export default {
  name: 'my-scrollbar',
  template: `
    <div class="c-scrollbar">
      <div class="c-scrollbar__content" v-html="content"></div>
    </div>
  `,
  props: {
    content: String
  },
  data () {
    return {
      ps: require('perfect-scrollbar'),
      el: null
    }
  },
  computed: {
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  mounted: function () {
    this.ps.initialize(this.$el, {
      theme: 'ukpn',
      suppressScrollX: true,
      scrollYMarginOffset: 12
    })

    this.el = this.$el.querySelector('p:not(:first-of-type) strong')
    if (this.el !== null) {
      this.el.addEventListener('click', () => {
        this.$emit('link-clicked')
      })
    }
  },
  watch: {
    windowWidth: function () {
      this.ps.update(this.$el)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/standard/my-scrollbar.js